module.exports = __webpack_public_path__ + "img/xiang3.6b0bf59c.png";